import {
  ACTION_GET_ROLES,
  ACTION_GET_ROLES_SUCCESS,
  ACTION_GET_ROLES_FAILURE,
  ACTION_EMPTY_ROLES,
  API_CALL,
} from '../../configs/ActionTypes';

import { Dispatch } from 'redux';

import { enqueueSnackbarHandler } from '../Status';

export function get(agencyId?: any) {
  return (dispatch: Dispatch, getState: Function) => {
    const route = agencyId || agencyId != null ? `roles/${agencyId}` : 'roles/';

    //Dispatch the api call request.
    dispatch({
      type: API_CALL,
      payload: {
        call: route,
        method: 'get',
        data: {},
        success: (response: any) => {
          if (response.type === 'error') {
            enqueueSnackbarHandler(dispatch, response.payload.payload, 'error');
            dispatch(requestFailed(response));
          } else {
            dispatch(requestSuccess(response));
          }
        },
        fail: (error: any) => {
          enqueueSnackbarHandler(dispatch, error.payload, 'error');
          dispatch(requestFailed(error));
        },
      },
    });

    dispatch(requestStarted());

    return null;
  };
}

export function emptyResults() {
  return (dispatch: Dispatch) => {
    dispatch({
      type: ACTION_EMPTY_ROLES,
      payload: null,
    });
  };
}

export function requestStarted() {
  return {
    type: ACTION_GET_ROLES,
    payload: null,
  };
}

export function requestSuccess(responseJSON: object) {
  return {
    type: ACTION_GET_ROLES_SUCCESS,
    payload: responseJSON,
  };
}

export function requestFailed(responseJSON: object) {
  return {
    type: ACTION_GET_ROLES_FAILURE,
    payload: responseJSON,
  };
}
